import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appEmbedData = { image: '_media' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _createMemberAboutRequest = { memberAbout: '_memberAbout' };
var _createMemberAboutResponse = { memberAbout: '_memberAbout' };
var _deleteMemberAboutRequest = {};
var _deleteMemberAboutResponse = {};
var _design = { poll: '_pollDesign' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getMemberAboutRequest = {};
var _getMemberAboutResponse = { memberAbout: '_memberAbout' };
var _getMyMemberAboutRequest = {};
var _getMyMemberAboutResponse = { memberAbout: '_memberAbout' };
var _image = { media: '_media' };
var _imageData = { image: '_media' };
var _item = { image: '_image', video: '_video' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _memberAbout = { content: '_richContent' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _queryMemberAboutsRequest = {};
var _queryMemberAboutsResponse = { memberAbouts: '_memberAbout' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _updateMemberAboutRequest = { memberAbout: '_memberAbout' };
var _updateMemberAboutResponse = { memberAbout: '_memberAbout' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
function resolveWixMembersAboutV2MembersAboutUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/members-about-api',
                destPath: '',
            },
            {
                srcPath: '/members/v2/abouts',
                destPath: '/v2/abouts',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/members-about-api',
                destPath: '',
            },
            {
                srcPath: '/members/v2/abouts',
                destPath: '/v2/abouts',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/members/v2/abouts',
                destPath: '/v2/abouts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates member about. */
export function createMemberAbout(payload) {
    var _a = serializer(_createMemberAboutRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _memberAbout: _memberAbout,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMemberAboutResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _memberAbout: _memberAbout,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __createMemberAbout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.about.v2.member_about',
            method: 'POST',
            methodFqn: 'wix.members.about.v2.MembersAbout.CreateMemberAbout',
            url: resolveWixMembersAboutV2MembersAboutUrl({
                protoPath: '/v2/abouts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMemberAbout.fromReq = fromReq;
    __createMemberAbout.__isAmbassador = true;
    return __createMemberAbout;
}
/** Updates an about content by ID. */
export function updateMemberAbout(payload) {
    var _a = serializer(_updateMemberAboutRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _memberAbout: _memberAbout,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMemberAboutResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _memberAbout: _memberAbout,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __updateMemberAbout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.about.v2.member_about',
            method: 'PATCH',
            methodFqn: 'wix.members.about.v2.MembersAbout.UpdateMemberAbout',
            url: resolveWixMembersAboutV2MembersAboutUrl({
                protoPath: '/v2/abouts/{memberAbout.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMemberAbout.fromReq = fromReq;
    __updateMemberAbout.__isAmbassador = true;
    return __updateMemberAbout;
}
/** Deletes an about. */
export function deleteMemberAbout(payload) {
    var _a = serializer(_deleteMemberAboutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMemberAboutResponse, {}).fromJSON;
    function __deleteMemberAbout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.about.v2.member_about',
            method: 'DELETE',
            methodFqn: 'wix.members.about.v2.MembersAbout.DeleteMemberAbout',
            url: resolveWixMembersAboutV2MembersAboutUrl({
                protoPath: '/v2/abouts/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMemberAbout.fromReq = fromReq;
    __deleteMemberAbout.__isAmbassador = true;
    return __deleteMemberAbout;
}
/** Retrieves an about by ID. */
export function getMemberAbout(payload) {
    var _a = serializer(_getMemberAboutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMemberAboutResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _memberAbout: _memberAbout,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __getMemberAbout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.about.v2.member_about',
            method: 'GET',
            methodFqn: 'wix.members.about.v2.MembersAbout.GetMemberAbout',
            url: resolveWixMembersAboutV2MembersAboutUrl({
                protoPath: '/v2/abouts/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMemberAbout.fromReq = fromReq;
    __getMemberAbout.__isAmbassador = true;
    return __getMemberAbout;
}
/** Retrieves current logged-in about */
export function getMyMemberAbout(payload) {
    var _a = serializer(_getMyMemberAboutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMyMemberAboutResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _memberAbout: _memberAbout,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __getMyMemberAbout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.about.v2.member_about',
            method: 'GET',
            methodFqn: 'wix.members.about.v2.MembersAbout.GetMyMemberAbout',
            url: resolveWixMembersAboutV2MembersAboutUrl({
                protoPath: '/v2/abouts/my',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMyMemberAbout.fromReq = fromReq;
    __getMyMemberAbout.__isAmbassador = true;
    return __getMyMemberAbout;
}
/**
 * Retries a list of up to 100 abouts, given the provided filters, sorting and paging.
 *
 * Currently supported fields for filtering:
 *
 * - `id`
 * - `member_id`
 */
export function queryMemberAbouts(payload) {
    var _a = serializer(_queryMemberAboutsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMemberAboutsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _memberAbout: _memberAbout,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
    }).fromJSON;
    function __queryMemberAbouts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.about.v2.member_about',
            method: 'POST',
            methodFqn: 'wix.members.about.v2.MembersAbout.QueryMemberAbouts',
            url: resolveWixMembersAboutV2MembersAboutUrl({
                protoPath: '/v2/abouts/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMemberAbouts.fromReq = fromReq;
    __queryMemberAbouts.__isAmbassador = true;
    return __queryMemberAbouts;
}
//# sourceMappingURL=http.impl.js.map